<template></template>

<script>
export default {
  created () {

    this.$store.dispatch('auth/destroyToken').then(response => {

      console.log('logout')
      this.$router.push({ name: 'auth-login' })
    })
  }
}
</script>
